<template>
    <!-- 竖柱状图 -->
    <div :ref="refId" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

// refId 图表id // datas 图表数据源 // transverseData 图表的x轴数据源 // colorList 柱状图的颜色值 //
innerText y轴上的单位 // legendList 图例组建的数据源 // seriesColor 判断柱状图是否需要渐变 //
gridHeight 图表的整体高度占比 // percentage 判断柱状图是普通类型还是堆叠的柱状图 // isRequired
判断tooltip悬停显示中的占比文字是否需要显示 // iscontrast 判断柱状图是否2跟柱子再tooltip中显示对比值
// gridWidth 占2个位置，增加图表宽度 // labelShow 是否在柱状图上面显示数值 // seriesBarWidth
显示的柱状图柱子大小 // axisLabelInterval 横轴数据是否显示齐全 // isShowTextColor
是否导出时候横轴纵轴显示黑色字 // isExportTextColor 是否给导出页面时候横轴纵轴显示设置字体25

<script>
import tools from "@/utils/tooltip";

export default {
    props: [
        "refId",
        "datas",
        "transverseData",
        "colorList",
        "innerText",
        "legendList",
        "seriesColor",
        "gridHeight",
        "percentage",
        "isRequired",
        "iscontrast",
        "gridWidth",
        "labelShow",
        "seriesBarWidth",
        "axisLabelInterval",
        "isShowTextColor",
        "isExportTextColor",
        "gridY",
        "nameGap",
        "gridLeft",
        "legendLeft",
    ],
    data() {
        return {
            pieEcharts: "",
            pieOption: {},
        };
    },
    watch: {
        datas: {
            handler(newValue, oldValue) {
                this.setPieOption(
                    this.refId,
                    newValue,
                    this.transverseData,
                    this.colorList,
                    this.innerText,
                    this.legendList,
                    this.seriesColor,
                    this.gridHeight,
                    this.percentage,
                    this.isRequired,
                    this.iscontrast,
                    this.gridWidth,
                    this.labelShow,
                    this.seriesBarWidth,
                    this.axisLabelInterval,
                    this.isShowTextColor,
                    this.isExportTextColor,
                    this.gridY,
                    this.nameGap,
                    this.gridLeft,
                    this.legendLeft,
                );
            },
            deep: true,
        },
    },
    beforeDestroy() {
        if (this.pieEcharts) {
            this.pieEcharts.clear();
        }
    },
    mounted() {
        if (this.datas.length > 0) {
            this.setPieOption(
                this.refId,
                this.datas,
                this.transverseData,
                this.colorList,
                this.innerText,
                this.legendList,
                this.seriesColor,
                this.gridHeight,
                this.percentage,
                this.isRequired,
                this.iscontrast,
                this.gridWidth,
                this.labelShow,
                this.seriesBarWidth,
                this.axisLabelInterval,
                this.isShowTextColor,
                this.isExportTextColor,
                this.gridY,
                this.nameGap,
                this.gridLeft,
                this.legendLeft,
            );
        }
    },
    methods: {
        isArray(data) {
            // 判断是否有多个柱状图
            let str1 = 1;
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    if (Array.isArray(data[i])) {
                        return (str1 = 2);
                    }
                    return (str1 = 1);
                }
            }
            return str1;
        },
        // 16进制颜色转化为rgba
        set16ToRgb(str, pellucidity) {
            const reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
            if (!reg.test(str)) {
                return;
            }
            let newStr = str.toLowerCase().replace(/\#/g, "");
            const len = newStr.length;
            if (len == 3) {
                let t = "";
                for (var i = 0; i < len; i++) {
                    t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
                }
                newStr = t;
            }
            const arr = []; // 将字符串分隔，两个两个的分隔
            for (var i = 0; i < 6; i += 2) {
                const s = newStr.slice(i, i + 2);
                arr.push(parseInt(`0x${s}`));
            }
            return `rgba(${arr.join(",")},${pellucidity})`;
        },

        setPieOption(
            refId,
            datas,
            transverseData,
            colorList,
            innerText,
            legendList,
            seriesColor,
            gridHeight,
            percentage,
            isRequired,
            iscontrast,
            gridWidth,
            labelShow,
            seriesBarWidth,
            axisLabelInterval,
            isShowTextColor,
            isExportTextColor,
            gridY,
            nameGap,
            gridLeft,
            legendLeft,
        ) {
            let arrList = [];
            let obj = {};
            let colors = "";
            console.log(this.datas);
            console.log(this.legendList);
            console.log(this.transverseData);
            if (!percentage) {
                // 普通的柱状图
                if (!legendList) {
                    legendList = [];
                }
                if (!innerText) {
                    innerText = "";
                } else {
                    innerText = innerText;
                }
                if (this.isArray(datas) == 2) {
                    for (let i = 0; i < datas.length; i++) {
                        colors = !seriesColor
                            ? this.$echarts.graphic.LinearGradient(1, 0, 0, 1, [
                                  {
                                      offset: 1,
                                      color: colorList[i],
                                  },
                                  {
                                      offset: 1,
                                      color: "rgba(52, 139, 231, 0)",
                                  },
                              ])
                            : colorList[i];
                        colors = JSON.stringify(colors);
                        obj = {
                            name: legendList[i],
                            data: datas[i],
                            type: "bar",
                            barWidth: seriesBarWidth || "",
                            itemStyle: {
                                normal: {
                                    color: JSON.parse(colors),
                                    barBorderRadius: [8, 8, 0, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                                    label: {
                                        show: !labelShow, // 开启显示
                                        position: "top", // 在上方显示
                                        textStyle: {
                                            // 数值样式
                                            color: "#707f9d",
                                            fontSize: isExportTextColor ? 25 : 16,
                                        },
                                    },
                                },
                            },
                        };
                        arrList.push(obj);
                    }
                } else {
                    obj = {
                        name: legendList[0],
                        data: datas,
                        type: "bar",
                        barWidth: seriesBarWidth || "",
                        itemStyle: {
                            normal: {
                                color: !seriesColor
                                    ? this.$echarts.graphic.LinearGradient(1, 0, 0, 1, [
                                          {
                                              offset: 0,
                                              color: colorList[0],
                                          },
                                      ])
                                    : colorList[0],
                                barBorderRadius: [8, 8, 0, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                                label: {
                                    show: !labelShow, // 开启显示
                                    position: "top", // 在上方显示
                                    textStyle: {
                                        // 数值样式
                                        color: "#707f9d",
                                        fontSize: isExportTextColor ? 25 : 16,
                                    },
                                },
                            },
                        },
                    };
                    arrList.push(obj);
                }
                arrList = JSON.stringify(arrList);
            } else {
                // 是否需要重叠一起的柱状图
                for (let i = 0; i < datas.length; i++) {
                    if (i == 0) {
                        obj = {
                            // 底层柱状
                            name: legendList[i],
                            type: "bar",
                            barWidth: seriesBarWidth || "",
                            itemStyle: {
                                normal: {
                                    color: !seriesColor
                                        ? new this.$echarts.graphic.LinearGradient(1, 0, 0, 1, [
                                              {
                                                  offset: 0,
                                                  color: colorList[i],
                                              },
                                              {
                                                  offset: 1,
                                                  color: "rgba(52, 139, 231, 0)",
                                              },
                                          ])
                                        : !seriesColor,
                                    barBorderRadius: [8, 8, 0, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                                    label: {
                                        show: labelShow, // 开启显示
                                        position: "top", // 在上方显示
                                        textStyle: {
                                            // 数值样式
                                            color: "#707f9d",
                                            fontSize: isExportTextColor ? 25 : 16,
                                        },
                                    },
                                },
                            },
                            z: -2,
                            data: datas[i],
                        };
                    } else {
                        obj = {
                            // 需要对比的柱状
                            name: legendList[i],
                            type: "bar",
                            symbol: "rect",
                            barGap: "-100%",
                            barWidth: seriesBarWidth || "",
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [8, 8, 0, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                                    label: {
                                        show: !!labelShow, // 开启显示
                                        position: "top", // 在上方显示
                                        textStyle: {
                                            // 数值样式
                                            color: "#707f9d",
                                            fontSize: isExportTextColor ? 25 : 16,
                                        },
                                    },
                                },
                            },
                            z: 2,
                            data: datas[i],
                        };
                    }
                    arrList.push(obj);
                }
                arrList = JSON.stringify(arrList);
            }

            this.pieEcharts = this.$echarts.init(this.$refs[refId]);
            this.pieOption = {
                legend: {
                    right: "center",
                    left: legendLeft ? legendLeft : "center",
                    bottom: "3%",
                    textStyle: {
                        color: isShowTextColor ? "#1d244e" : "#bcc2cf",
                        fontSize:
                            isShowTextColor && !isExportTextColor
                                ? 17
                                : isShowTextColor && isExportTextColor
                                ? 25
                                : 12,
                    },
                    data: legendList,
                },
                grid: {
                    left: gridLeft ? gridLeft : "2%",
                    right: "4%",
                    bottom: "15%",
                    containLabel: true,
                    x: "12%", // x 偏移量
                    y: gridY ? gridY : "12%", // y 偏移量
                    width: gridWidth ? "94.5%" : "92%", // 宽度
                    height: gridHeight || "75%", // 高度
                },
                tooltip: {
                    trigger: "axis",
                    confine: true, // 浮窗限制在图表内
                    backgroundColor: "rgba(64, 80, 118, 0.8)", // 通过设置rgba调节背景颜色与透明度
                    borderColor: "rgba(64, 80, 118, 0.8)",
                    color: "#fff",
                    textStyle: {
                        color: "#fff",
                    },
                    axisPointer: {
                        type: "shadow",
                        label: {
                            backgroundColor: "#6a7985",
                        },
                    },
                    formatter: params => {
                        let src = "";
                        if (params) {
                            src = `${params[0].name}<br />`;
                        }
                        for (let i = 0; i < params.length; i++) {
                            src += `${params[i].marker} ${
                                params[i].seriesName.indexOf("series") == -1
                                    ? params[i].seriesName
                                    : ""
                            } &nbsp;&nbsp; ${params[i].value}<br/>`;
                        }
                        if (iscontrast) {
                            src += `${params[1].seriesName}${isRequired || ""}&nbsp;&nbsp; ${
                                ((params[1].value / params[0].value) * 100).toFixed(2)
                                    ? ((params[1].value / params[0].value) * 100).toFixed(2)
                                    : 0
                            }%`;
                        }
                        return src;
                    },
                },
                xAxis: {
                    type: "category",
                    data: transverseData,
                    axisLine: {
                        show: true,
                    }, // x轴是否有刻度线
                    axisTick: {
                        show: false,
                        lineStyle: {
                            type: "dotted",
                        },
                    }, // 刻度
                    splitLine: {
                        show: false,
                        lineStyle: {
                            // type: "dashed",  //虚线
                            color: "rgba(255,255,255,0.3)",
                        },
                    }, // 分隔线
                    axisLabel: {
                        // x轴坐标轴样式
                        interval: axisLabelInterval ? 0 : null, // 每次间隔几个标签显示
                        textStyle: {
                            color: isShowTextColor ? "#1d244e" : "#bcc2cf",
                            fontSize:
                                isShowTextColor && !isExportTextColor
                                    ? 14
                                    : isShowTextColor && isExportTextColor
                                    ? 25
                                    : 12,
                        },
                    },
                },
                yAxis: {
                    name: `${innerText}`,
                    nameGap: nameGap ? nameGap : 25,
                    nameTextStyle: {
                        align: "left",
                        color: isShowTextColor ? "#1d244e" : "#bcc2cf",
                        fontSize:
                            isShowTextColor && !isExportTextColor
                                ? 14
                                : isShowTextColor && isExportTextColor
                                ? 25
                                : 16,
                    },
                    type: "value",
                    axisLine: { show: true }, // 轴线
                    axisTick: {
                        show: false,
                        lineStyle: {
                            type: "dotted",
                        },
                    }, // 刻度
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed", // 虚线
                            color: "rgba(255,255,255,0.3)",
                        },
                    }, // 分隔线
                    axisLabel: {
                        // x轴坐标轴样式
                        textStyle: {
                            color: isShowTextColor ? "#1d244e" : "#bcc2cf",
                            fontSize:
                                isShowTextColor && !isExportTextColor
                                    ? 14
                                    : isShowTextColor && isExportTextColor
                                    ? 25
                                    : 16,
                        },
                    },
                },

                series: JSON.parse(arrList),
            };

            // 渲染图表
            this.pieEcharts.setOption(this.pieOption);

            if (percentage) {
                // 使用轮播插件,填入相关参数
                tools.autoHover(this.pieEcharts, this.pieOption, transverseData.length, 2000);
            }

            window.addEventListener("resize", () => {
                this.pieEcharts.resize();
            });
        },
    },
};
</script>

<style scoped></style>
